/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import LCD from '@appblocks/codegeneration/Features/LCD';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const widget = project.getFeature(feature.getSettingValue('WIDGET'));
    const LCDFeature = project.getFeature('lcd') as LCD;
    if (!LCDFeature) return blocks;
    const LCDWidgets = LCDFeature.getSettingValue('WIDGETS');
    let imgWidgetIndex = 0;

    let LCD_TEXT_WIDGETS_COUNT = 0;
    let LCD_IMG_WIDGETS_COUNT = 0;
    for (let i = 0; i < project.features.length; i++) {
        const feature = project.features[i];
        for (let j = 0; j < feature.settings.length; j++) {
            const setting = feature.settings[j];
            if (setting.refId === 'display_screen'
                && setting.settingType === SettingType.ARRAY) {
                const SCREENS = feature.getSettingValue('SCREENS');
                for (let k = 0; k < SCREENS.length; k++) {
                    const widgets = SCREENS[k].getSettingValue('WIDGETS');
                    for (let l = 0; l < widgets.length; l++) {
                        if (widgets[l].id === 'lcd_text_widget') {
                            LCD_TEXT_WIDGETS_COUNT++;
                        } else if (widgets[l].id === 'lcd_image_widget') {
                            if (widget?.getID() === widgets[l].getID()) {
                                imgWidgetIndex = LCD_IMG_WIDGETS_COUNT;
                                break;
                            }
                            LCD_IMG_WIDGETS_COUNT++;
                        }
                    }
                }
            }
        }
    }

    if (!widget) return blocks;
    const img = project.getFeature(feature.getSettingValue('IMG'));
    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    const links = project.getNodeLinks(feature, 'lcd_image');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        // const x_offset = project.getNodeParameter(link, 'x_offset');
        // const y_offset = project.getNodeParameter(link, 'y_offset');
        const IMG_FILE = img ? img.getSettingValue('IMG').split('\n')[0] : '';
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
    lcd_img_widgets(${imgWidgetIndex}).filename = "${IMG_FILE}"
    lcd_display_img_widget(lcd_img_widgets(${imgWidgetIndex}))
    ${doneBlock}`,
        });
    }

    return blocks;
};
